import Const from 'constants';
import FetchWrapper from 'helpers/fetch-wrapper';
import {shouldMaxSalaryBeUpdated} from 'helpers/sport-config';
import API from 'api';
import UserAgent from 'helpers/device';

let SportConfig = {
    getSportConfig(sport, site, gameType, mode) {
        return (dispatch) => {
            dispatch({
                type: Const.GET_SPORT_CONFIG_REQUEST,
            });

            const url = API.to('GET_SORT_CONFIG', {sport, site, gameType, mode});
            return FetchWrapper.fetchGet(url)
                .then((json) => {
                    dispatch({
                        type: Const.GET_SPORT_CONFIG_SUCCESS,
                        data: json.data,
                    });

                    // #DFSA-708
                    if (UserAgent.isMobile()) {
                        dispatch(this.updateMaxSalaryIfNeeded());
                    }

                    dispatch(this.setOuterSalaryCapFromSportConfig());

                    return Promise.resolve(json);
                })
                .catch((error) =>
                    dispatch({
                        type: Const.GET_SPORT_CONFIG_FAILURE,
                        data: error,
                        error: true,
                    }),
                );
        };
    },
    updateMaxSalaryIfNeeded() {
        return (dispatch, getState) => {
            const {
                sportConfig,
                playersData: {slates},
            } = getState();
            const slate = slates.getById(sportConfig.getSlateId());

            if (!shouldMaxSalaryBeUpdated(slate, sportConfig)) {
                return;
            }

            dispatch({
                type: Const.UPDATE_MAX_SALARY,
                data: slate.max_salary_cap,
            });

            dispatch(this.setOuterSalaryCapFromSportConfig());
        };
    },
};

export default SportConfig;
